







import { Component, Vue, Prop } from '@/common'

@Component({})
export default class TwIcon extends Vue {
  @Prop({})
  name!: string;

  get iconName() {
    return `#el-icon-${this.name}`;
  }

  click(){
    this.$emit("click");
  }
}
